import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { update } from 'actions/onboarding';
import { useQuery } from '@apollo/client';
import { analyticsEvents, eventCategories, track } from 'util/analytics';
import airbrake from 'util/airbrake';
import GEOLOCATE_QUERY from './GeolocateQuery.gql';

export function Geolocate(props) {
  const { loading, error, data } = useQuery(GEOLOCATE_QUERY, { ssr: false });

  useEffect(() => {
    if (!loading && !error && data?.geolocate) {
      switch (data.geolocate.name) {
        case 'LA':
          props.update({
            city: 'Los Angeles',
            state: 'CA',
            market: data.geolocate,
            areasOfInterest: [data.geolocate],
          });
          break;
        case 'DC':
          props.update({
            city: 'Washington',
            state: 'DC',
            market: data.geolocate,
            areasOfInterest: [data.geolocate],
          });
          break;
        case 'New York':
          props.update({
            city: 'New York',
            state: 'NY',
            market: data.geolocate,
            areasOfInterest: [data.geolocate],
          });
          break;
        default:
          props.update({
            city: data.geolocate.name,
            state: data.geolocate.state,
            market: data.geolocate,
            areasOfInterest: [data.geolocate],
          });
      }
      track(analyticsEvents.geolocate, {
        category: eventCategories.location_autoset,
        label: `location autoset to ${data.geolocate.name}`,
      });
    }
  }, [loading]);

  if (error) {
    airbrake.notify({ error });
  }

  return null;
}

Geolocate.propTypes = {
  update: PropTypes.func.isRequired,
};
export default connect(null, {
  update,
})(Geolocate);
